// extracted by mini-css-extract-plugin
module.exports = {"root":"PrimaryButton_root__2WprR","fullWidth":"PrimaryButton_fullWidth__RNghf"};